import { Component, OnInit, EventEmitter, Output, Input, ElementRef, ViewChild } from '@angular/core';
import { MatCheckboxChange, MatCheckbox } from '@angular/material';
import { OccurencesService } from '../../occurences.service';
import { OccurenceType } from '../../model/occurence-type.model';
import { NgForm, FormGroup } from '@angular/forms';
import { DateOccurrenceType } from '../../model/date-occurrence-type.model';
import { UtilService } from '@app/shared/utils';
import { CONSTANTS } from '@app/shared/constants';

@Component({
  selector: 'app-occurence-types',
  templateUrl: './occurence-types.component.html',
  styleUrls: ['./occurence-types.component.css']
})
export class OccurenceTypesComponent implements OnInit {

  @ViewChild('ocurrenceTypes') ocurrenceTypesElem;
  @Input('ngForm')
  public ngForm: NgForm;
  @Input('typesForm')
  public typesForm: FormGroup;
  @Input()
  public isVisualization: boolean;
  @Input()
  public typesChecked: Array<DateOccurrenceType>;
  @Output()
  newSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  occurenceTypesChangeEvt: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  manageDataFields: EventEmitter<any> = new EventEmitter<any>();


  occurrenceTypes: Array<OccurenceType>;
  occurenceTypesSubscription: any;
  typesSelectedList: Array<OccurenceType> = new Array<OccurenceType>();

  constructor(
    private occurrencesService: OccurencesService,
    private utils: UtilService,
    private elRef: ElementRef) { }

  ngOnInit() {
    this.getOccurenceTypes();
    this.occurenceTypesChangeEvt.emit(this.occurrenceTypes);
  }

  getOccurenceTypes() {
    this.occurenceTypesSubscription = this.occurrencesService.getOccurenceTypes().subscribe((list: Array<OccurenceType>) => {
      list.forEach(item => {
        item.disabled = false;
        if (this.utils.containsTypeOpenImpl(item.name)) {
          item.messageDisable = CONSTANTS.INFO_DISABLE_OCC_TYPE_OPEN_IMPL;
        } else {
          item.messageDisable = CONSTANTS.INFO_DISABLE_NEW_EVENTS;
        }
      }
      );
      this.occurrenceTypes = list;
      if (this.isVisualization) {
        this.occurrenceTypes.forEach(occurrencType => {
          occurrencType.disabled = true;
        });
      }
      this.threatOccurrenceTypesChecked();
    });
  }

  onChange(e: MatCheckboxChange) {
    this.handleValidateDisabledInputs(e);

    const occurenceType: OccurenceType = new OccurenceType(+e.source.id, e.source.name);

    if (e.checked) {
      this.typesSelectedList.push(occurenceType);
    } else {
      const removeIndex = this.typesSelectedList.map(function (item) { return item.id; }).indexOf(occurenceType.id);
      this.typesSelectedList.splice(removeIndex, 1);
    }

    this.typesForm.controls.typesListControl.setValue(this.typesSelectedList);
    this.newSelect.emit(this.typesSelectedList);
  }

  handleValidateDisabledInputs(e): void {
    const type = e.source;

    if (!e.checked && this.typesSelectedList.length === 1) {
      this.occurrenceTypes.forEach(occurrencType => {
        occurrencType.disabled = false;
      });

    } else if (this.utils.containsTypeOpenImpl(type.name)) {
      this.manageDataFields.emit(true);
      this.occurrenceTypes.forEach(occurrencType => {
        
        if (!this.utils.containsTypeOpenImpl(occurrencType.name)) {
          occurrencType.disabled = true;
        }
      });
    } else {
      this.occurrenceTypes.forEach(occurrencType => {
        if (this.utils.containsTypeOpenImpl(occurrencType.name)) {
          occurrencType.disabled = true;
        }
      });
    }
  }

  havePortfolioSelected(event: boolean): void {
    this.occurrenceTypes.forEach(occurrencType => {
      if (this.utils.containsTypeOpenImpl(occurrencType.name)) {
        if (event) {
          occurrencType.disabled = true;
          occurrencType.checked = false;
        } else {
          occurrencType.disabled = false;
        }
      }
    });
  }

  containsTypeOpenImpl(name): Boolean {
    return this.utils.containsTypeOpenImpl(name);
  }

  threatOccurrenceTypesChecked(): void {
    if (Array.isArray(this.occurrenceTypes) && this.occurrenceTypes.length > 0
      && Array.isArray(this.typesChecked) && this.typesChecked.length > 0) {
      this.occurrenceTypes.forEach((item) => {
        this.typesChecked.forEach((typeChecked) => {
          if (typeChecked.occurrenceType.id === item.id) {
            item.checked = true;
            this.typesSelectedList.push(typeChecked.occurrenceType);
          }
        });
      });
      this.newSelect.emit(this.typesSelectedList);
    }
  }

  disableAllCheckboxes(): void {
    this.occurrenceTypes.forEach(occurrencType => {
      occurrencType.disabled = true;
    });
  }
}
